// extracted by mini-css-extract-plugin
module.exports = {"noteText":"ResumeStep_noteText__3PzY6","clearSubmission":"ResumeStep_clearSubmission__3yNTC","submitAnotherFm":"ResumeStep_submitAnotherFm__ZfjAf"};